module.exports = __webpack_public_path__ + "assets/b189eccc0c2612b9c389bdbb8a62fe25.png";